import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
import { Star, ShieldCheck } from 'lucide-react';
export function PricingCard() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 1,
    minutes: 30,
    seconds: 5
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 1;
          minutes = 30;
          seconds = 5;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="py-12 px-4 sm:px-6 bg-cream border-y-8 border-gold/20 scroll-mt-4" data-id="element-141">
      <div className="text-center mb-8" data-id="element-142">
        <p className="text-sm font-body font-bold text-gold uppercase tracking-widest mb-2" data-id="element-143">
          SPECIAL OFFER — COMPLETE 6-IN-1 PACK
        </p>
        <h2 className="text-2xl sm:text-3xl font-heading font-bold text-petrol mb-4 leading-tight" data-id="element-144">
          Access the system now and transform your senior fitness classes today.
        </h2>

        <div className="inline-block bg-sage text-white px-4 py-1.5 rounded shadow-sm mb-6" data-id="element-145">
          <p className="font-body font-bold text-sm tracking-widest uppercase" data-id="element-146">
            FITNESS SENIOR READY™ 6-in-1 Box Set
          </p>
        </div>

        <a href="https://fitness-senior-ready.impultienda.ar/checkout" className="block cursor-pointer mb-8" data-id="element-147">
          <img src="https://cdn.magicpatterns.com/uploads/3BY8BrEsHe6M5N1YF9C6Vd/ChatGPT-Image-16-jun-2026_-15_07_04.webp" alt="FITNESS SENIOR READY 6-in-1 Box Set" className="w-full max-w-[280px] mx-auto object-contain drop-shadow-xl" data-id="element-148" />
        </a>
      </div>

      <div className="max-w-md mx-auto bg-ivory border-4 border-gold rounded-2xl p-6 sm:p-8 text-center relative mb-8 shadow-2xl" data-id="element-149">
        <div className="mb-6" data-id="element-150">
          <p className="text-base font-bold text-graphite/70 mb-1" data-id="element-151">
            Normal Price: <span className="line-through" data-id="element-152">$97 USD</span>
          </p>
          <p className="text-lg font-body font-bold text-[#D9381E] mb-2 uppercase tracking-widest" data-id="element-153">
            🔥 72% OFF — LAUNCH OFFER
          </p>
          <p className="text-6xl font-heading font-extrabold text-petrol mb-2 leading-none" data-id="element-154">
            $27 USD
          </p>
          <p className="text-xs font-bold text-graphite/60 uppercase tracking-widest" data-id="element-155">
            Pay in your local currency
          </p>
        </div>

        <div className="bg-[#FFF5F3] border border-[#FFDCD3] rounded-xl p-4 mb-8" data-id="element-156">
          <p className="text-sm font-bold text-[#D9381E] mb-3 uppercase tracking-wide" data-id="element-157">
            🔥 Last chance! The price increases when the timer ends.
          </p>
          <div className="flex justify-center gap-3" data-id="element-158">
            <div className="text-center" data-id="element-159">
              <div className="bg-petrol text-white text-2xl font-body font-bold px-3 py-2 rounded-lg shadow-inner leading-none min-w-[56px]" data-id="element-160">
                {String(timeLeft.hours).padStart(2, '0')}
              </div>
              <p className="text-[10px] font-bold text-petrol/70 mt-1.5 tracking-widest" data-id="element-161">
                HOURS
              </p>
            </div>
            <div className="text-2xl font-bold text-petrol mt-1.5" data-id="element-162">:</div>
            <div className="text-center" data-id="element-163">
              <div className="bg-petrol text-white text-2xl font-body font-bold px-3 py-2 rounded-lg shadow-inner leading-none min-w-[56px]" data-id="element-164">
                {String(timeLeft.minutes).padStart(2, '0')}
              </div>
              <p className="text-[10px] font-bold text-petrol/70 mt-1.5 tracking-widest" data-id="element-165">
                MINUTES
              </p>
            </div>
            <div className="text-2xl font-bold text-petrol mt-1.5" data-id="element-166">:</div>
            <div className="text-center" data-id="element-167">
              <div className="bg-petrol text-white text-2xl font-body font-bold px-3 py-2 rounded-lg shadow-inner leading-none min-w-[56px]" data-id="element-168">
                {String(timeLeft.seconds).padStart(2, '0')}
              </div>
              <p className="text-[10px] font-bold text-petrol/70 mt-1.5 tracking-widest" data-id="element-169">
                SECONDS
              </p>
            </div>
          </div>
        </div>

        <CTAButton href="https://fitness-senior-ready.impultienda.ar/checkout" data-id="element-170">
          🚀 YES, I WANT THE 6-IN-1 PACK
        </CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-3 sm:gap-8 text-sm text-graphite font-bold" data-id="element-171">
        <div className="flex items-center gap-2" data-id="element-172">
          <Star className="w-5 h-5 fill-gold text-gold" data-id="element-173" />
          <span data-id="element-174">4.9/5 — Verified Reviews</span>
        </div>
        <div className="flex items-center gap-2" data-id="element-175">
          <ShieldCheck className="w-5 h-5 text-sage" data-id="element-176" />
          <span data-id="element-177">7-Day Guarantee — Zero Risk</span>
        </div>
      </div>
    </section>;
}